import { Components } from "@thisgorilla/primate-ds";
import styled, { useTheme } from "styled-components";
import { FlexColumn, FlexRow, FlexRowCenter } from "../../Styles";

const UserList = () => {
  const { typography } = useTheme();
  return (
    <FlexColumn $gapInPx={8}>
      <Components.Text
        text="Send in Chat"
        style={{ tokenStyle: typography.Heading.S }}
        fontWeight="font-weight-semibold"
      />
      <FlexRow $gapInPx={10}>
        {Array.from({ length: 5 }).map((_, index) => (
          <AvatarContainer key={index}>
            <Components.Avatar
              size="Large-56"
              src="https://i.pravatar.cc/150?img=67"
              type="Circle"
            />
            <Components.Text
              text="Nathan Curtis"
              style={{ tokenStyle: typography.Body.XS }}
              lineHeight="line-height-25"
            />
            {index === 0 && (
              <AvatarStatusIndicator>
                <Components.StatusIndicator
                  iconType="Check"
                  state="Brand"
                  color="#F3F5F6"
                />
              </AvatarStatusIndicator>
            )}
          </AvatarContainer>
        ))}
        <AvatarContainer>
          <MoreButton>
            <Components.Icon type="MoreHorizontal" size="24px" />
          </MoreButton>
          <Components.Text
            text="More"
            style={{ tokenStyle: typography.Body.XS }}
            lineHeight="line-height-25"
            fontWeight="font-weight-semibold"
          />
        </AvatarContainer>
      </FlexRow>
    </FlexColumn>
  );
};

export default UserList;

const AvatarContainer = styled(FlexColumn)`
  position: relative;
  max-width: ${({ theme }) => theme.spacing["spacing-14"].value}rem;
  label {
    text-align: center;
  }
`;

const AvatarStatusIndicator = styled.div`
  position: absolute;
  top: ${({ theme }) => theme.spacing["spacing-9"].value}rem;
  right: 0;
`;

const MoreButton = styled(FlexRowCenter)`
  cursor: pointer;
  width: ${({ theme }) => theme.spacing["spacing-14"].value}rem;
  height: ${({ theme }) => theme.spacing["spacing-14"].value}rem;
  background-color: ${({ theme }) =>
    theme.Color.background.neutral.subtle.default.value};
  border-radius: ${({ theme }) => theme.radius["radius-full-round"].value}rem;
  &:hover {
    background-color: ${({ theme }) =>
      theme.Color.background.neutral.subtle.hover.value};
  }
`;
